var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627.62 901.4H265.23c-56.91 0-103.05-46.14-103.05-103.05V262.8c0-56.91 46.14-103.05 103.05-103.05h362.38c56.91 0 103.04 46.13 103.04 103.04v34.78c0 15.26-12.37 27.63-27.63 27.63s-27.63-12.37-27.63-27.63V262.8c0-26.39-21.39-47.79-47.79-47.79H265.23c-26.39 0-47.78 21.39-47.78 47.78v535.57c0 26.39 21.39 47.77 47.77 47.77h362.39c26.39 0 47.77-21.39 47.77-47.77V769.6c0-15.26 12.37-27.63 27.63-27.63s27.63 12.37 27.63 27.63v28.76c0.02 56.91-46.12 103.04-103.02 103.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M853.72 508.65L731.19 386.12c-10.79-10.79-28.29-10.79-39.08 0s-10.79 28.29 0 39.08l75.18 75.18 1.17 1.12h-301c-15.26 0-27.63 12.37-27.63 27.63s12.37 27.63 27.63 27.63h299.09l-83.76 83.76c-10.86 10.86-9.69 27.27 2.59 36.48 12.28 9.21 31.21 7.87 42.07-2.99l126.28-126.28c10.79-10.79 10.79-28.28-0.01-39.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1fa52a5da9b241deed4562ee2fa3b6dd.svg";
export { ForwardRef as ReactComponent };